import { motion } from "framer-motion";

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const STEPS = [
  {
    num: "01",
    title: "Evaluación de lote",
    body: "Cultivo, plaga objetivo, dosis y viento. Antes de despegar ya sabemos qué gota necesita tu hoja.",
  },
  {
    num: "02",
    title: "Calibración",
    body: "Caudal, ancho de pasada y tamaño de gota ajustados al producto y a la ventana climática del día.",
  },
  {
    num: "03",
    title: "Vuelo de aplicación",
    body: "Pasadas paralelas con traslape declarado y franjas de protección respecto a personas, viviendas, apiarios y fuentes de agua.",
  },
  {
    num: "04",
    title: "Ficha técnica firmada",
    body: "Hectáreas, litros por hectárea y dosis aplicada, entregados por escrito al productor. Lo que no se registra, no se cobra.",
  },
];

const Protocolo = () => (
  <section id="protocolo" data-testid="protocolo-section" className="bg-[#F6F7F5] text-[#151A1F] py-24 sm:py-32 border-t border-[#151A1F]/10">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <motion.p {...reveal} className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#046A38]">
            Protocolo operativo
          </motion.p>
          <motion.h2
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.1 }}
            className="font-display font-bold tracking-tight leading-[1.08] text-2xl sm:text-4xl lg:text-5xl mt-6"
          >
            Publicamos cómo trabajamos.
          </motion.h2>
          <motion.p
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.15 }}
            className="mt-6 text-base text-[#151A1F]/70 leading-relaxed"
          >
            Nuestro protocolo es propio, está basado en referencia internacional y se lo entregamos
            firmado a cada productor.
          </motion.p>
          <motion.p
            {...reveal}
            transition={{ ...reveal.transition, delay: 0.2 }}
            className="mt-6 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-[#6B7280] leading-relaxed"
          >
            Protocolo propio basado en referencia internacional
          </motion.p>
        </div>

        <div className="lg:col-span-7">
          <div className="border-t border-l border-[#151A1F]/10">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.num}
                data-testid={`protocolo-step-${s.num}`}
                {...reveal}
                transition={{ ...reveal.transition, delay: i * 0.1 }}
                className="group grid grid-cols-[auto_1fr] gap-6 border-b border-r border-[#151A1F]/10 p-6 sm:p-8 hover:bg-white transition-colors duration-500"
              >
                <span className="font-display font-bold text-3xl sm:text-4xl text-[#00A651] tabular">{s.num}</span>
                <div>
                  <h3 className="font-display font-semibold text-lg sm:text-xl tracking-tight">{s.title}</h3>
                  <p className="mt-2 text-sm sm:text-base text-[#151A1F]/65 leading-relaxed">{s.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Protocolo;
